module.exports = function getResource(label, vars = []) {
    const resources = {
        joinButton: 'Join',
        createAccount: 'Create an Account'
    };

    return resources[label];
};
